<figure class="flex-installation-drawing">
    <figcaption>{{ caption }}</figcaption>
    <div class="drawing-content">
        <app-loader [isLoading]="isLoading && !hasDrawing" [isPositionAbsolute]="false"></app-loader>
        <canvas
            #pipeCanvas
            [class.hidden]="!hasDrawing"
            [attr.role]="hasDrawing ? 'img' : null"
            [attr.aria-label]="hasDrawing ? ariaLabel : null"
            [attr.aria-hidden]="!hasDrawing"
        ></canvas>
        <div *ngIf="!isLoading && !hasDrawing" class="drawing-unavailable">
            <ng-container *ngIf="hasRenderError || resource.state === 'error'; else drawingEmpty">
                {{ 'DIAGNOSTICS.FLEX_MONITOR_STATUS.DRAWING_ERROR' | translate }}
            </ng-container>
            <ng-template #drawingEmpty>
                {{
                    (isPipeInstallation
                        ? 'DIAGNOSTICS.FLEX_MONITOR_STATUS.DRAWING_UNAVAILABLE'
                        : 'DIAGNOSTICS.FLEX_MONITOR_STATUS.DRAWING_NOT_APPLICABLE'
                    ) | translate
                }}
            </ng-template>
        </div>
        <div *ngIf="hasDrawing && resource.state === 'error'" class="drawing-warning" aria-live="polite">
            {{ 'DIAGNOSTICS.FLEX_MONITOR_STATUS.DRAWING_REFRESH_ERROR' | translate }}
        </div>
    </div>
</figure>
